import { NumericFormat } from 'react-number-format';
import styled from 'styled-components';

export const StyledNumeric = styled(NumericFormat)<{
    isEdited?: boolean;
    fontSize?: string;
    isNotInTable?: boolean;
    hasValue?: boolean;
}>`
    border: 1px solid ${(props) => props.isNotInTable && !props.hasValue
        ? 'rgba(200, 80, 80, 0.5)'
        : 'var(--color-alt-second-10)'};
    border-radius: 6px;
    width: ${(props) => props.isNotInTable ? '80%' : '50%'};
    text-align: right;
    cursor: pointer;
    padding: 3px 10px;
    background-color: var(--color-white);

    box-shadow: ${(props) => props.isNotInTable && !props.hasValue
        ? '0 0 10px rgba(200, 80, 80, 0.4)'
        : 'none'};

    &:focus {
        outline: none;
        font-style: italic;
    }

    font-size: ${(props) => props.fontSize ? props.fontSize : 'inherit'};
    font-weight: 600;
`;

export const StyledTextInput = styled.input<{ isEdited?: boolean, fontSize?: string }>`
    border: 1px solid var(--color-alt-second-10);
    border-radius: 6px;
    width: 80%;
    text-align: left;
    cursor: pointer;
    padding: 3px 10px;
    background-color: var(--color-white);

    &:focus {
        outline: none;
        font-style: italic;
    }

    font-size: ${(props) => props.fontSize ? props.fontSize : 'inherit'};
    font-weight: 600;
`;

